import {Component, ViewEncapsulation} from '@angular/core';

import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
    encapsulation: ViewEncapsulation.None,
        imports: [RouterOutlet]
})
export class ContentComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
